export default __webpack_public_path__ + "static/earthquake-c902c2ce51ddc8b3209b03395ea46722.jpg";